export default {
    title_list: 'Типы документов',
    title_page: 'Тип документа',
    title_create_page: 'Создать тип документа',
    title_edit_page: 'Изменить тип документа',

    filter: {
        labels: {
            title: 'Название',
            position: 'Позиция'
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Название',
            position: 'Позиция'
        }
    },

    buttons: {

    },

    form: {
        title: 'Название',
        position: 'Позиция'
    },
}
